<template>
    <el-drawer :visible.sync="isShow" direction="rtl" ref="drawer" :size="'90%'" :show-close="true"
        :destroy-on-close="true" @close="close" append-to-body>
        <div class="container">
            <div class="column">
                <div class="title">已选资源（图片p，视频m。鼠标指向后单击<i class="el-icon-close" />移除）</div>
                <div class="box" style="height: 100%;">
                    <div class="file-list">
                        <div class="file-card" v-for="(file, index) in files" :key="index">
                            <img :src="getImgUrl(file)" />
                            <div class="mask">
                                <i v-if="isVideo(file)" class="el-icon-video-play" @click="preview(0, index)"></i>
                                <i v-else class="el-icon-view" @click="preview(0, index)"></i>
                                <i class="el-icon-close" @click="removeFile(index)"></i>
                            </div>
                            <div class="triangle"></div>
                            <div class="remark">{{ isVideo(file) ? 'm' : 'p' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="title">备选资源（鼠标指向后单击<i class="el-icon-check" />添加）</div>
                <div class="right">
                    <div class="box resource">
                        <div class="sub-title">图片资源</div>
                        <div class="file-list">
                            <div class="file-card" v-for="(file, index) in images" :key="index">
                                <img :src="baseUrl + file" />
                                <div class="mask">
                                    <i class="el-icon-view" @click="preview(1, index)"></i>
                                    <i class="el-icon-check" @click="addFile(1, index)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box resource">
                        <div class="sub-title">视频资源</div>
                        <div class="file-list">
                            <div class="file-card" v-for="(file, index) in videos" :key="index">
                                <img :src="getImgUrl(file)" />
                                <div class="mask">
                                    <i class="el-icon-video-play" @click="preview(2, index)"></i>
                                    <i class="el-icon-check" @click="addFile(2, index)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <media-preview ref="mediaPreview"></media-preview>

        </div>
    </el-drawer>
</template>

<script>
export default {
    props: {
        value: [String, Object, Array],
        maxNumber: { type: Number, default: 999 }
    },
    data() {
        return {
            isShow: false,
            baseUrl: process.env.VUE_APP_BASE_API,
            images: [],
            videos: [],
            files: []
        }
    },
    methods: {
        //添加文件
        addFile(type, index) {
            if (this.files.length >= this.maxNumber) {
                this.$message(`最多允许选择${this.maxNumber}个文件`)
                return
            }
            if (type === 1) {
                this.files.push(this.images[index])
                this.images.splice(index, 1);
            }
            else {
                this.files.push(this.videos[index])
                this.videos.splice(index, 1);
            }
        },
        //移除文件
        removeFile(index) {
            const file = this.files[index];
            if (this.isVideo(file)) this.videos.push(file);
            else this.images.push(file);
            this.files.splice(index, 1);
        },
        //是视频?
        isVideo(file) {
            if (file.indexOf(".mp4") > -1) return true;
            return false;
        },
        //获取图片（视频封面）
        getImgUrl(file) {
            if (file === undefined) return "#";
            if (file.indexOf(".mp4") > -1) file = file.replace(".mp4", ".jpg");
            return this.baseUrl + file;
        },
        //预览
        preview(type, index) {
            let files = [];
            if (type === 0) files = this.files.map(el => this.baseUrl + el); //已选资源
            else if (type === 1) files = this.images.map(el => this.baseUrl + el);//图片资源
            else if (type === 2) files = this.videos.map(el => this.baseUrl + el); //视频资源
            this.$refs.mediaPreview.open(files, index);  //打开拾取器
        },
        //打开选择框
        open(images, videos) {
          console.log("pick-value：",this.value);
            this.isShow = true;
            if (Array.isArray(images)) this.images = [...images]; //解构赋值，不然会影响父组件中的images
            if (Array.isArray(videos)) this.videos = [...videos];
            //根据 value 生成 files
            if (this.$utils.isValid(this.value)) this.files = this.value.split(',')
            else this.files = []
            //排除已选图片及视频
            this.files.forEach(el => {
                let index = this.images.indexOf(el);
                if (index > -1) this.images.splice(index, 1);
                index = this.videos.indexOf(el);
                if (index > -1) this.videos.splice(index, 1);
            });
        },
        //关闭选择框
        close() {
            this.isShow = false;
            let value = this.files.join(",");
            this.$emit("input", value);
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
}

.column {
    flex: 1;
    height: 95h;
    display: flex;
    flex-direction: column;
}

.right {
    display: flex;
    flex-direction: column;
}

.box {
    margin: 10px;
    display: flex;
    flex-direction: column;
    border: 1px dashed #1890ff;
    border-radius: 6px;
}

.resource {
    height: 45vh;
}

.title {
    margin-left: 25px;
}

.sub-title {
    margin: 10px 10px 0 10px;
    padding-bottom: 10px;
    /* border-bottom: 1px dashed black; */
}

.file-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    overflow-y: auto;
}

.file-card {

    width: 146px;
    height: 146px;
    margin: 10px;

    display: flex;
    background-color: rgb(214, 212, 212);
    border-radius: 6px;

    position: relative;

    img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: contain;
    }

    video {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    /* 遮罩 */
    .mask {

        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        font-size: 22px;
        color: white;
        border-radius: 6px;
        background-color: black;
        opacity: 0;

        display: flex !important;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 15px;

        i {
            cursor: pointer;
        }

    }

    /* 遮罩显示*/
    .mask:hover {
        opacity: 0.5;
    }
}


.triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    border-top-right-radius: 5px;
    background: linear-gradient(45deg, transparent 50%, rgb(109, 189, 109) 50%);
}

.remark {
    position: absolute;
    z-index: 5;
    top: 0px;
    right: 4px;
    transform: rotate(45deg);
    color: white;
}



/* 穿透 css 作用域 */
::v-deep .el-drawer__header {
    margin: 0;
    padding: 0;
}
</style>